import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const catIcons: Record<string, string> = {
  热血: 'ri-fire-fill',
  恋爱: 'ri-heart-3-fill',
  奇幻: 'ri-magic-fill',
  悬疑: 'ri-question-line',
  校园: 'ri-school-line',
  搞笑: 'ri-emotion-laugh-fill',
  科幻: 'ri-rocket-2-fill',
  冒险: 'ri-compass-3-fill',
};

export default function CategoriesSection() {
  const list = categories.filter((c) => c !== '全部');
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-secondary-700">
            <span className="inline-block h-2 w-2 rounded-full bg-secondary-500"></span>漫画分类
          </p>
          <h2 className="font-heading mt-3 text-2xl text-foreground-950 md:text-4xl">
            按喜好发现好漫画
          </h2>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {list.map((c) => (
          <Link
            key={c}
            to={`/comics?category=${encodeURIComponent(c)}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-1 hover:border-primary-200"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-lg text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={catIcons[c] || 'ri-book-2-line'}></i>
            </span>
            <div>
              <h3 className="text-sm font-bold text-foreground-950">{c}</h3>
              <p className="text-xs text-foreground-500">浏览{c}作品</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}